/* 🤖 this file was generated by svg-to-ts */
export const matIconTableRows: {
  name: 'table-rows';
  data: string;
} = {
  name: 'table-rows',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H5V5h14zm0 5v4H5v-4h14zM5 19v-3h14v3H5z"/></svg>`
};
